import { Box, Collapse, Text, useBoolean } from "@chakra-ui/react";
import React from "react";
import { useLocation } from "react-router-dom";
import { RouteLink } from "shared/components/link/RouteLink";
import { NavigationItem } from "shared/components/navbar/NavigationItem";
import { ChevronDownIcon } from "shared/icons/ChevronDownIcon";
import { isCurrentLocation } from "shared/utils/utils";

export interface SidebarNavProps {
  items: NavigationItem[];
}

export const SidebarNavItem: React.FC<{
  item: NavigationItem;
}> = ({ item: { name, href, items } }) => {
  const location = useLocation();

  const isCurrent = href ? isCurrentLocation(location, href) : false;
  const [isOpen, { toggle: toggleOpen }] = useBoolean(
    () =>
      items?.some(
        (item) => item.href && isCurrentLocation(location, item.href),
      ) ?? false,
  );

  return (
    <Box width="100%">
      <RouteLink
        to={href}
        prefetch={true}
        onClick={(event) => {
          if (items) {
            event.preventDefault();
            toggleOpen();
          }
        }}
        px="24px"
        py="8px"
        lineHeight="24px"
        display="flex"
        alignItems="center"
        textDecoration="none"
        colorScheme="gray"
        textColor={isCurrent ? "gray.800" : "gray.500"}
        fontSize="16px"
        _hover={{
          bg: "white",
        }}
      >
        <Text
          borderBottomWidth="1px"
          borderColor={isCurrent ? "gray.800" : "transparent"}
        >
          {name}
        </Text>
        {items && (
          <ChevronDownIcon
            width="20px"
            height="20px"
            color="gray.500"
            ml="8px"
            transform="auto"
            transitionProperty="common"
            transitionDuration="normal"
            rotate={isOpen ? 0 : -180}
          />
        )}
      </RouteLink>
      {items && (
        <Collapse in={isOpen}>
          <Box pl="16px">
            <SidebarNav items={items} />
          </Box>
        </Collapse>
      )}
    </Box>
  );
};

const SidebarNav: React.FC<SidebarNavProps> = ({ items }) => (
  <>
    {items.map((item, i) => (
      <SidebarNavItem key={`item_${i}`} item={item} />
    ))}
  </>
);

export default SidebarNav;
